import Tree from "../trees/Tree.jsx";
import TreeRed from "../trees/TreeRed.jsx";
import TreeYellow from "../trees/TreeYellow.jsx";
import TreeOrange from "../trees/TreeOrange.jsx";
import MiniTreeGreen from "../trees/MiniTreeGreen.jsx";
import MiniTreeRed from "../trees/MiniTreeRed.jsx";
import MiniTreeYellow from "../trees/MiniTreeYellow.jsx";
import MiniTreeOrange from "../trees/MiniTreeOrange.jsx";
import PointerGameZone from "../pointers/PointerGameZone.jsx";
import PointerWorkZone from "../pointers/PointerWorkZone.jsx";
import PointerHobbyZone from "../pointers/PointerHobbyZone.jsx";
import FloorBlock from "../race/block/FloorBlock.jsx";
import TreeAllColor from "../trees/TreeAllColor.jsx";
import PointerShadow from "../pointers/PointerShadow.jsx";

const Crossroad = ({ position = [0, 0, 0] }) => {
  return (
    <group position={position}>
      <FloorBlock position={[-4, 0, -8]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[-7, 0, -5]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[4, 0, -8]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[7, 0, -5]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[7, 0, 5]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[4, 0, 8]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[-4, 0, 8]} scale={0.3} rotation={[0, 0, 0]} />
      <FloorBlock position={[-7, 0, 5]} scale={0.3} rotation={[0, 0, 0]} />
      <TreeAllColor position={[0, 0, 1]} rotation={[0, 0, 0]} />
      <Tree position={[8, 0, -9]} rotation={[0, Math.PI / 2, 0]} />
      <MiniTreeGreen position={[4, 0, -13]} rotation={[0, 0, 0]} />
      <MiniTreeGreen position={[12, 0, -5]} rotation={[0, 0, 0]} />
      <TreeRed position={[-8, 0, -9]} rotation={[0, Math.PI * 1.25, 0]} />
      <MiniTreeRed position={[-12, 0, -5]} rotation={[0, 0, 0]} />
      <MiniTreeRed position={[-4, 0, -13]} rotation={[0, 0, 0]} />
      <TreeYellow position={[8, 0, 9]} rotation={[0, Math.PI, 0]} />
      <MiniTreeYellow position={[12, 0, 5]} rotation={[0, 0, 0]} />
      <MiniTreeYellow position={[4, 0, 13]} rotation={[0, 0, 0]} />
      <TreeOrange position={[-8, 0, 9]} rotation={[0, Math.PI * 1.5, 0]} />
      <MiniTreeOrange position={[-12, 0, 5]} rotation={[0, 0, 0]} />
      <MiniTreeOrange position={[-4, 0, 13]} rotation={[0, 0, 0]} />
      <group position={[-4.5, 0, 0]}>
        <PointerShadow width={4.9} height={2.4} opacity={0.6} softness={0.8} />
      </group>
      <PointerGameZone
        position={[-4, 0, 4]}
        rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
      />
      <PointerWorkZone position={[4.5, 0, 0]} rotation={[0, 0, 0]} />
      <PointerHobbyZone position={[0, 0, 4]} rotation={[0, 0, 0]} />
    </group>
  );
};

export default Crossroad;
